import { Heading } from "@chakra-ui/react";

export default function SectionHeading({ title }: { title: string }) {
  return (
    <Heading
      as="h6"
      fontSize="14px"
      fontWeight="600"
      lineHeight="21px"
      mb="8px"
    >
      {title}
    </Heading>
  );
}
